// extracted by mini-css-extract-plugin
module.exports = {"question":"QuestionSingle_question__1wZyI","button":"QuestionSingle_button__13HT3","textarea":"QuestionSingle_textarea__g0AEo"};